import React, { PropTypes } from 'react';
import Modal from 'react-modal';
import Translate from 'react-translate-component';
import Envelope from '../../svg/envelope';
import EnvelopeOpen from '../../svg/envelope-open';
import ShieldCheck from '../../svg/shield-check';
import Umbrella from '../../svg/umbrella';
import Heart from '../../svg/heart';

class LojaltyInfoModal extends React.Component {

  static propTypes = {
    close: PropTypes.func
  };

  render () {
    return (
      <Modal
        className='modal'
        contentLabel=''
        isOpen
        onRequestClose={this.props.close}>
        <div className='modal-content loyalty-info-modal'>
          <button className='close' onClick={this.props.close}/>
          <div>
            <h2><Translate content='LOYALTY_INFO_MODAL_TITLE'/></h2>
            <div className='difference-wrapper'>
              <div className='difference-col'>
                <h3 className='difference-title'>
                  <Translate content='LOYALTY_INFO_MODAL_PREREGISTER_TITLE'/>
                </h3>
                <ul>
                  <li>
                    <span className='layalty-info-modal-icon'>
                      <EnvelopeOpen
                        width='30'
                        height='30'
                        colorSchema='primary'
                      />
                    </span>
                    <Translate content='LOYALTY_INFO_MODAL_PREREGISTER_MAIL_TEXT'/>
                  </li>
                  <li>
                    <span className='layalty-info-modal-icon'>
                      <Heart
                        width='30'
                        height='30'
                        colorSchema='primary'
                      />
                    </span>
                    <Translate content='LOYALTY_INFO_MODAL_PREREGISTER_HEART_TEXT'/>
                  </li>
                  <li>
                    <span className='layalty-info-modal-icon'>
                      <Umbrella
                        width='30'
                        height='30'
                        colorSchema='primary'
                      />
                    </span>
                    <Translate content='LOYALTY_INFO_MODAL_PREREGISTER_UMBRELLA_TEXT'/>
                  </li>
                  <li>
                    <span className='layalty-info-modal-icon'>
                      <ShieldCheck
                        width='30'
                        height='30'
                        colorSchema='primary'
                      />
                    </span>
                    <Translate content='LOYALTY_INFO_MODAL_PREREGISTER_SHIELD_TEXT'/>
                  </li>
                </ul>
              </div>
              <div className='difference-col'>
                <h3 className='difference-title'>
                  <Translate content='LOYALTY_INFO_MODAL_INVOICE_TITLE'/>
                </h3>
                <ul>
                  <li>
                    <span className='layalty-info-modal-icon'>
                      <Envelope
                        width='30'
                        height='30'
                        colorSchema='primary'
                      />
                    </span>
                    <Translate content='LOYALTY_INFO_MODAL_INVOICE_MAIL_TEXT'/>
                  </li>
                  <li>
                    <span className='layalty-info-modal-icon'>
                      <Heart
                        width='30'
                        height='30'
                        colorSchema='primary'
                      />
                    </span>
                    <Translate content='LOYALTY_INFO_MODAL_INVOICE_HEART_TEXT'/>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }

}

export default LojaltyInfoModal;



/** WEBPACK FOOTER **
 ** ./src/components/modal/loyalty-info-modal/loyalty-info-modal.js
 **/